import { inject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { SalesForecastService } from 'pages/sales-forecast/service';
import * as FilePond from 'filepond';

@inject(DialogController, SalesForecastService)
export class ImportMonthlyVolume {
  constructor(controller, salesForecastService) {
    this.controller = controller;
    this.salesForecastService = salesForecastService;
  }

  attached() {
    this.fileDrop = FilePond.create(this.fileInput);
    this.fileDrop.on('addfile', (error, file) => {
        this.csv = file.file;
        this.response = null;
        this.testRan = false;
    });
  }

  async import() {
    if (this.isRequesting || this.csv == null) return;
    this.isRequesting = true;
    try {
      this.response = await this.salesForecastService.importMonthlyVolume(this.csv);
    } finally {
      this.isRequesting = false;
    }
    this.isRequesting = false;
    this.controller.ok();
  }
}